import type { Params } from "./model";

export const VOLATILITY_PERIODS = [
  { value: "1y", label: "최근 1년" },
  { value: "180d", label: "최근 180일" },
  { value: "90d", label: "최근 90일" },
  { value: "custom", label: "날짜 직접 지정" },
  { value: "observations", label: "최근 N거래일" },
];

export function isIsoDate(value: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return (
    Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value
  );
}

/** The upstream prioritizes observation count over dates; send only the selected mode. */
export function volatilityWindow(p: Params): {
  volatility_date_to: string;
  volatility_date_from?: string;
  stockprice_query_period?: number;
} {
  const to = p.valuation_date || "";
  if (!isIsoDate(to)) throw new Error("평가기준일을 확인해 주세요.");
  // Saved evaluations created before period selection used an explicit start date.
  const mode = p.volatility_period || "custom";
  if (mode === "observations") {
    const count = Number(p.stockprice_query_period);
    if (!Number.isSafeInteger(count) || count < 3)
      throw new Error("주가 관측수는 3개 이상의 정수로 입력해 주세요.");
    return { volatility_date_to: to, stockprice_query_period: count };
  }
  let from = p.volatility_date_from || "";
  if (mode !== "custom") {
    const date = new Date(`${to}T00:00:00Z`);
    if (mode === "1y") {
      const month = date.getUTCMonth();
      date.setUTCFullYear(date.getUTCFullYear() - 1);
      if (date.getUTCMonth() !== month) date.setUTCDate(0);
    } else if (mode === "180d" || mode === "90d") {
      date.setUTCDate(date.getUTCDate() - (mode === "180d" ? 180 : 90));
    } else throw new Error("주가 조회기간을 선택해 주세요.");
    from = date.toISOString().slice(0, 10);
  }
  if (!isIsoDate(from) || from >= to)
    throw new Error("주가 조회 시작일은 평가기준일보다 이전이어야 합니다.");
  return { volatility_date_from: from, volatility_date_to: to };
}

export function volatilityWindowText(window: Record<string, unknown>) {
  if (Number(window.stockprice_query_period) > 0)
    return `${window.volatility_date_to} 기준 최근 ${Number(window.stockprice_query_period).toLocaleString("ko-KR")}거래일`;
  return `${window.volatility_date_from || "—"} ~ ${window.volatility_date_to || "—"}`;
}
